import api from './ApiHandler';
import { LOGIN_USER } from './ApiConstants';

export const getUserLogin = async ({
  userName,
  password
}: {
  userName: String;
  password: String;
}) => {
  return await api.post(LOGIN_USER, { userName, password });
};
